<div *ngIf="(filter$|async) as filter"  class="flex flex-row justify-between items-center full-grow-no-shrink-no-basis ">
  <div  class="full-grow-no-shrink-no-basis ">
    <particle-filter-summary-input-container
      *ngFor="let filterSummaryItem of filter.leftFilterSummaries"
      [filterSummaryItem]="filterSummaryItem"
      [filter]="filter"
      [invalidateSubject]="invalidateSubject"
    >
    </particle-filter-summary-input-container>
  </div>
  <div class="m-l-15 flex flex-col justify-start items-center">
    <div *ngIf="!(hasFeature$ | async)(VisitorFeature)" class="flex flex-row">
      <!--date range-->
      <particle-date-range-input (dateRange)="onDateChange($event)"></particle-date-range-input>
    </div>
    <div *ngIf="((hasFeature$ | async)(VisitorFeature))" class="flex flex-col" >
      <!--single date-->
      <div class="m-r-20 flex flex-col justify-center items-start">
        <label class="component-label datepicker-label">Date</label>
        <div class="grid-toolbar-buttons-group m-t-10">
          <label>{{toDay | date}}</label>
        </div>
      </div>
    </div>
  </div>
</div>

